module.exports = __webpack_public_path__ + "user3/user3-3d4abba013e076fe8083bba8d5310b6a.png";